/**
 * Popup
 */
/* eslint-disable */
export function popup(popupBtn, popupPanel, popupClose, popupType = 'popup') {
    const popup = {
        panel: document.querySelector(popupPanel),
        openBtn: document.querySelector(popupBtn),
        closeBtns: document.querySelectorAll(popupClose),
    };

    if (!popup.openBtn || !popup.panel) return;

    popup.openBtn.addEventListener('click', function (e) {
        e.preventDefault();
        this.classList.toggle('active');
        popup.panel.classList.toggle('active');
        document.body.style.overflow = 'hidden';
        // document.body.classList.toggle('popup-opened');

        popup.panel.style.minHeight
            ? (popup.panel.style.minHeight = null)
            : (popup.panel.style.minHeight = popup.panel.scrollHeight + 'px');

        if (
            popup.panel.classList.contains('active') &&
            popupType != 'accordion'
        ) {
            // document.body.style.overflow = 'hidden';
            document.addEventListener('click', function (e) {
                if (
                    popup.panel.contains(e.target) ||
                    popup.openBtn.contains(e.target)
                )
                    return;

                popup.panel.classList.remove('active');
                popup.openBtn.classList.remove('active');
                document.body.style.overflow = 'visible';
                // document.body.classList.remove('popup-opened');
            });
        }
    });

    // popup.panel.classList.contains('opened') && popup.openBtn.dispatchEvent(new Event('click'));

    if (!popup.closeBtns) return;

    popup.closeBtns.forEach(function (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
            popup.panel.classList.remove('active');
            popup.openBtn.classList.remove('active');
            document.body.style.overflow = 'visible';
            // document.body.classList.remove('popup-opened');

            popup.panel.style.maxHeight
                ? (popup.panel.style.maxHeight = null)
                : (popup.panel.style.maxHeight =
                      popup.panel.scrollHeight + 'px');
        });
    });
}
